import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class ProgramRoute extends Route {
  @service currentUser;
  @service permissionChecker;
  @service store;

  queryParams = {
    leadershipDetails: {
      replace: true,
    },
    manageLeadership: {
      replace: true,
    },
  };

  canUpdate = false;

  beforeModel(transition) {
    this.currentUser.requireNonLearner(transition);
  }

  model(params) {
    return this.store.findRecord('program', params.program_id);
  }

  async afterModel(program) {
    const permissionChecker = this.permissionChecker;
    this.canUpdate = await permissionChecker.canUpdateProgram(program);
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.set('canUpdate', this.canUpdate);
  }
}
